import React, {Component} from 'react';
import Yorum from '../components/Yorum';
import YorumForm from "../components/YorumForm";
import { database } from '../firebase';

class Yorumlar extends Component {
constructor(props) {
    super(props);
    this.database = database.ref(`yorumlar/${window.location.pathname.slice(2)}`);
    this.state = {
      yorumlar: [],
    };
}

componentWillMount() {
    const previousComments = this.state.yorumlar;
    this.database.on('child_added', snap => {
        previousComments.push({
          id: snap.key,
          commentAuthor: snap.val().commentAuthor,
          commentContent: snap.val().commentContent,
          commentDate: snap.val().commentDate,
        })
        
        this.setState({
          yorumlar: previousComments,
        })
    })
    this.database.on('child_removed', snap => {
        for (var i = 0; i < previousComments.length; i++) {
            if (previousComments[i].id === snap.key) {
                previousComments.splice(i, 1);
            }
        }
        this.setState({
          yorumlar: previousComments,
        })
    })
}

render() {return (
  <div id="yorumlar">
    <YorumForm/>
    <h4 className="a" style={{margin: "0", marginBottom: "20px", userSelect: "none"}}>Yorumlar ( {this.state.yorumlar.length||"0"} )</h4>
    {this.state.yorumlar.map((yorum) => {return (
      <Yorum commentContent={yorum.commentContent}
            commentAuthor={yorum.commentAuthor}
            commentDate={yorum.commentDate}
            commentId={yorum.id}
            key={yorum.id}/>
    )}).reverse()}
  </div>
)}};

export default Yorumlar;